import store from "../store";
// import translate from "../languages/index"

let lang = localStorage.getItem("language") || store.state.language || "pt";
let translate = {
  pt: {
    passLength: "A senha deve conter exatamente 8 caracteres",
    required: "Campo obrigatório",
    phoneCounter: "Digite um número válido (DDD + Número)",
    birthdate: "Proibido menores de 18 anos!",
    birthdateDay: "Dia inválido",
    birthdateMonth: "Mês inválido",
    birthdateYear: "Ano inválido",
    birthdateInvalid: "Data de nascimento inválida",
    passMin: "Mínimo 8 caracteres contendo letras e números",
    passCaracter: "Obrigatório ter ao menos letras e números",
    max: "Você atingiu o máximo de 50 caracteres",
    docMax: "Você atingiu o máximo de 50 caracteres",
    docCPF: "O documento CPF deve conter 14 caracteres",
    nameValid: "Digite Nome e Sobrenome",
    validateCPF: "CPF Inválido",
    validEmail: "Digite um email válido.",
    usernameMax: "Digite no mínimo 5 caracteres",
    usernameAz09: "Digite um login válido",
    emailAlreadyRegistered: "E mail já cadastrado no sistema",
    loginAlreadyRegistered: "Login já cadastrado no sistema",
    noSpacesAreAllowed: "Não são permitidos espaços",
    cvvDigitsCount: "Campo incompleto",
    wrongValidateCart: "Formato de data inválido",
    validateCreditCardNumber: "Cartão inválido!",
    minLengthToken: "O token deve conter 8 caracteres.",
    invalidEmailDomain: "Esse domínio de email não é válido.",
    noSpecialCharAllowed: "O código não pode conter caracteres especiais"
  },
  en: {
    passLength: "Password must contain exactly 8 characters",
    required: "Required field",
    phoneCounter: "Please enter a valid number",
    birthdate: "No children under 18!",
    birthdateDay: "Invalid day",
    birthdateMonth: "Invalid month",
    birthdateYear: "Invalid year",
    birthdateInvalid: "Invalid date of birth",
    passMin: "Minimum 8 characters containing letters and numbers",
    passCaracter: "Must have at least letters and numbers",
    max: "You reached the maximum of 50 characters",
    docMax: "You reached the maximum of 50 characters",
    docCPF: "The CPF document must contain 14 characters",
    nameValid: "Enter First and Last Name",
    validateCPF: "Invalid CPF",
    validEmail: "Please enter a valid email.",
    usernameMax: "Please enter at least 5 characters",
    usernameAz09: "Please enter a valid login",
    emailAlreadyRegistered: "Email already registered in the system",
    loginAlreadyRegistered: "Login already registered in the system",
    noSpacesAreAllowed: "No spaces allowed",
    cvvDigitsCount: "Incomplete field",
    wrongValidateCart: "Invalid date format",
    validateCreditCardNumber: "Invalid card!",
    minLengthToken: "The token must contain 8 characters.",
    invalidEmailDomain: "This email domain is not valid.",
    noSpecialCharAllowed: "The code cannot include special characters"
  },
  es: {
    passLength: "La contraseña debe contener exactamente 8 caracteres",
    required: "Campo obligatorio",
    phoneCounter: "Introduzca un número válido",
    birthdate: "¡No se admiten niños menores de 18 años!",
    birthdateDay: "Día inválido",
    birthdateMonth: "Mes inválido",
    birthdateYear: "Año no válido",
    birthdateInvalid: "Fecha de nacimiento invalida",
    passMin: "Mínimo 8 caracteres que contienen letras y números",
    passCaracter: "Debe tener al menos letras y números",
    max: "Has alcanzado el máximo de 50 caracteres",
    docMax: "Has alcanzado el máximo de 50 caracteres",
    docCPF: "El documento CPF debe contener 14 caracteres",
    nameValid: "Ingrese nombre y apellido",
    validateCPF: "CPF no válido",
    validEmail: "Ingrese un correo electrónico válido.",
    usernameMax: "Por favor ingrese al menos 5 caracteres",
    usernameAz09: "Introduzca un nombre de usuario válido",
    emailAlreadyRegistered: "Correo electrónico ya registrado en el sistema",
    loginAlreadyRegistered: "Inicio de sesión ya registrado en el sistema",
    noSpacesAreAllowed: "No se permiten espacios",
    cvvDigitsCount: "Campo incompleto",
    wrongValidateCart: "Formato de fecha inválido",
    validateCreditCardNumber: "¡Tarjeta no valida!",
    minLengthToken: "El token debe contener 8 caracteres.",
    invalidEmailDomain: "Este dominio de correo electrónico no es válido.",
    noSpecialCharAllowed: "El código no puede tener caracteres especiales"
  },
};

const validate = {
  required: (value) => !!value || translate[lang].required,
  max: (value) => (value && value.length <= 50) || translate[lang].max,
  docMax: (value) => (value && value.length === 11) || translate[lang].docMax,
  docCPF: (value) => (value && value.length === 14) || translate[lang].docCPF,
  nameValid: (value) => {
    return /[A-z]{2} [A-z]{2}/.test(value) || translate[lang].nameValid;
  },
  phoneCounter: (value) =>
    (value && value.length >= 16 && value && value.length <= 17) ||
    translate[lang].phoneCounter,
  phoneCounter2: (value) =>
    (value && value.length >= 15 && value && value.length <= 16) ||
    translate[lang].phoneCounter,
  phoneCounterMask: (value) =>
    (value && value.length >= 14 && value && value.length <= 15) ||
    translate[lang].phoneCounter,
  phoneCounterMaskPR: (value) =>
    (value && value.length >= 11 && value && value.length <= 12) ||
    translate[lang].phoneCounter,
  phoneCounterMaskBR: (value) =>
    (value && value.length >= 15 && value && value.length <= 16) ||
    translate[lang].phoneCounter,
  phoneValid: (value) => {
    return (
      /^\([1-9]{2}\) 9[0-9]{4}-[0-9]{4}$/.test(value) ||
      translate[lang].phoneCounter
    );
  },
  birthdate: (value) => {
    const cond = !!value;
    if (cond) {
      let date = value.includes("-")
        ? value.split("-")
        : value.includes("/")
        ? value.split("/")
        : "";
      let day = date[0];
      let month = date[1];
      let year = date[2];
      let ageYear = parseInt(year) + 18;
      let setDate = new Date(ageYear, month - 1, day);
      let currdate = new Date();
      let yearA = currdate.getFullYear();
      if (day > 31 || (day <= 0 && day.length > 1)) {
        return translate[lang].birthdateDay;
      } else if (month > 12 || (month <= 0 && month.length > 1)) {
        return translate[lang].birthdateMonth;
      } else if (year > yearA || (year <= 0 && year.length > 3)) {
        return translate[lang].birthdateYear;
      } else if (yearA - year > 100) {
        return translate[lang].birthdateInvalid;
      } else if (value.length <= 9) {
        return translate[lang].birthdateInvalid;
      } else if (currdate <= setDate) {
        return translate[lang].birthdate;
      } else {
        return true;
      }
    } else {
      return translate[lang].required;
    }
  },
  passLength: (value) =>
    (value && value.length == 8) || translate[lang].passLength,
  passMin: (value) => (value && value.length >= 8) || translate[lang].passMin,
  passCaracter: (value) => {
    return (
      (/^[A-Za-z0-9\d=!\-@._*]*$/.test(value) &&
        /[a-z]/.test(value) &&
        /\d/.test(value)) ||
      translate[lang].passCaracter
    );
  },
  validEmail: (value) => {
    // /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    // /^[a-zA-Z0-9.]+@([a-zA-Z0-9]+\.)+[a-zA-Z]{2,}$/
    const re = /^[\w\-.]+@([\w]+\.)[\w-]{2,3}([.br]{1,3})?$/;

    return !value ? true : re.test(value) || translate[lang].validEmail;
  },
  usernameMax: (v) => (v && v.length >= 5) || translate[lang].usernameMax,
  usernameAz09: (v) => {
    return (
      (/^[A-Za-z0-9\d=!\-@._*]*$/.test(v) && /[a-z]/.test(v)) ||
      translate[lang].usernameAz09
    );
  },
  validateCPF: (cpf) => {
    if (typeof cpf !== "string") return translate[lang].validateCPF;
    cpf = cpf.replace(/[\s.-]*/gim, "");
    var soma = 0;
    var resto;
    for (var i = 1; i <= 9; i++)
      soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto == 10 || resto == 11) resto = 0;
    if (resto != parseInt(cpf.substring(9, 10)))
      return translate[lang].validateCPF;
    soma = 0;
    for (var i = 1; i <= 10; i++)
      soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;
    if (resto == 10 || resto == 11) resto = 0;
    if (resto != parseInt(cpf.substring(10, 11)))
      return translate[lang].validateCPF;
    if (
      !cpf ||
      cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999"
    )
      return translate[lang].validateCPF;
    return true;
  },
  noSpacesAreAllowed: (v) =>
    (v || "").indexOf(" ") < 0 || translate[lang].noSpacesAreAllowed,
  cvvDigitsCount: (v) => (v && v.length >= 3) || translate[lang].cvvDigitsCount,
  wrongValidateCart: (value) => {
    const cond = !!value;
    if (cond) {
      // retrieving current date to check if card's year is valid
      const currentDate = new Date();
      let currentYear2Digits = currentDate
        .getFullYear()
        .toString()
        .slice(2, 4);

      let userInputDate = value;
      let handleInputDate = value.split("/");
      let month = handleInputDate[0];
      let cardYear = handleInputDate[1];
      if (month > 12 || cardYear < currentYear2Digits || userInputDate < 3) {
        return translate[lang].wrongValidateCart;
      } else {
        return true;
      }
    } else {
      return false;
    }
  },
  validateCreditCardNumber: (number) => {
    if (number == undefined) return;
    let reversed = number
      .replaceAll(" ", "")
      .toString()
      .split("")
      .reverse()
      .join("");
    let total = 0;

    for (let i = 0; i < reversed.length; i++) {
      let currentDigit = parseInt(reversed[i]);
      if (i % 2 === 1) {
        currentDigit *= 2;
        if (currentDigit > 9) {
          currentDigit -= 9;
        }
      }
      total += currentDigit;
    }

    return total % 10 === 0 || translate[lang].validateCreditCardNumber;
  },
  lengthToken: (token) => (token && token.length == 8) || translate[lang].minLengthToken,
  noSpecialChar: v => /^[a-zA-Z0-9]+$/.test(v) || translate[lang].noSpecialCharAllowed,

  validateEmailDomain: (email) => {
    if (!email) {
      return true;
    }

    // const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // if (!re.test(email)) {
    // return translate[lang].validEmail;
    // }

    const validDomains = [
      "gmail.com",
      "hotmail.com",
      "yahoo.com.br",
      "outlook.com",
      "uol.com.br",
      "ig.com.br",
      "bol.com.br",
      "terra.com.br",
      "globo.com",
      "r7.com",
      "oi.com.br",
      "live.com",
      "zipmail.com.br",
      "superig.com.br",
      "net.br",
      "yahoo.com",
      "aol.com",
      "icloud.com",
      "live.com",
      "ymail.com",
      "mail.com",
      "protonmail.com",
      "zoho.com",
      "gmx.com",
      "comcast.net",
      "verizon.net",
      "att.net",
      "cox.net",
      "charter.net",
      "sbcglobal.net",
      "mail.ru",
      "163.com",
      "qq.com",
    ];

    let valid = false;

    const emailDomain = email.split("@")[1];

    validDomains.forEach((domain) => {
      if (emailDomain === domain) {
        valid = true;
      }
    });

    if (valid) {
      return true;
    } else {
      return translate[lang].invalidEmailDomain;
    }
  },
};

export { validate };
